import { exctractorDto } from "../../app/modules/exctractors/dto/ExtractorDto";
import { LicencesDto } from "../../app/modules/licences/dto/LicencesDto";
import { profileDto } from "../../app/modules/profile/dto/profileDto";
import { tenantDto } from "../../app/modules/tenants/dto/tenantDto";
import { userDto } from "../../app/modules/users/dto/userDto";

export const dtoRepo = {
  users: userDto,
  profile: profileDto,
  extractors: exctractorDto,
  licences: LicencesDto,
  tenants: tenantDto,
}